import { render, staticRenderFns } from "./LinkTenantSetting.vue?vue&type=template&id=23d6eecc&scoped=true"
import script from "./LinkTenantSetting.vue?vue&type=script&lang=js"
export * from "./LinkTenantSetting.vue?vue&type=script&lang=js"
import style0 from "./LinkTenantSetting.vue?vue&type=style&index=0&id=23d6eecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d6eecc",
  null
  
)

export default component.exports